import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import { auth } from './firebase/config.js'
//vSelect
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';
//import reactiveStorage from "vue-reactive-storage";
//start session Storage Plugin
//import VueSessionStorage from "vue-sessionstorage";
//Vue.use(VueSessionStorage);
//end session Storage Plugin

//plugins
//import VModal from 'vue-js-modal/dist/index.nocss.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
//import CoolSelectPlugin from 'vue-cool-select'

//theme
// Import Bootstrap an BootstrapVue CSS files (order is important)
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

import '../scss/custom.scss'  // theming bootstrap

//import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-js-modal/dist/styles.css'

Vue.config.productionTip = false

//Vue.use(VModal)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// START vue-reactive-storage: Set initial values
/*Vue.use(reactiveStorage, {
    "orgId": 'd37SloAGeFNnFkbWpHuq',
    "dmShop": 'Amici di Tobia (MI)',
    "name": 'foo',
    "count": 1,
    "userParam": {orgId: 'd37SloAGeFNnFkbWpHuq', uid: ''}
});*/

/*auth.onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
  //this.localStorage.userParam.uid = user.uid
});
*/
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')